import { ReactNode } from "react";
import { useTranslation } from "react-i18next";

export function useInfoToggleName(label: ReactNode): string {
  const { t } = useTranslation();

  return typeof label === "string"
    ? t("aboutField", { label, interpolation: { escapeValue: false } })
    : t("moreInformation");
}
